export default (editor, config = {}) => {
  const bm = editor.BlockManager;
  const pfx = 'emp-weather';
  const style = `<style>
    .${pfx} {} 
    .${pfx}-container {
     width: 100%;
     height: 100%;
     pointer-events: none;
     border-radius: 15px;
     padding: 1em;
    }
  </style>`;
  bm.add('Weather', {
    label: 'Weather',
    category: 'Widget',
    content: `
        <div  data-gjs-type="social-icons-weather"></div>
        ${style}
      `,
    attributes: {
      class: 'fa fa-sun-o', //icon in the panel
    },
  });
};



// WEBPACK FOOTER //
// ./src/plugins/weather/blocks.js